import { render } from "./DefaultItem.vue?vue&type=template&id=6e168020"
import script from "./DefaultItem.vue?vue&type=script&lang=js"
export * from "./DefaultItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__